import { render, staticRenderFns } from "./registerSuccess.vue?vue&type=template&id=77a2f62f&scoped=true"
import script from "./registerSuccess.vue?vue&type=script&lang=js"
export * from "./registerSuccess.vue?vue&type=script&lang=js"
import style0 from "./registerSuccess.vue?vue&type=style&index=0&id=77a2f62f&prod&lang=less&scoped=true"
import style1 from "./registerSuccess.vue?vue&type=style&index=1&id=77a2f62f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77a2f62f",
  null
  
)

export default component.exports